import StoresSelection from './StoresSelection';
export default StoresSelection;